import AscOrdersPage from './AscOrdersPage';

export default AscOrdersPage;
